export class TestResultDTO {
  scenario: string;
  settings: any;
  prompt: string;
  userQuestion: string;
  response: string;
  metrics: {
    inputTokens: number;
    outputTokens: number;
    totalTokens: number;
    responseTime: number;
    tokensUsed?: number;
    responseStartLatency?: number;
    responseCompleteLatency?: number;
  } = {
    inputTokens: 0,
    outputTokens: 0,
    totalTokens: 0,
    responseTime: 0
  };
  timestamp: Date;

  constructor() {
    this.timestamp = new Date();
  }

  bindData(obj: any): void {
    if (!obj) return;

    this.scenario = obj.scenario;
    this.settings = obj.settings;
    this.prompt = obj.prompt;
    this.userQuestion = obj.userQuestion;
    this.response = obj.response;
    this.timestamp = obj.timestamp ? new Date(obj.timestamp) : new Date();

    if (obj.metrics) {
      this.metrics.inputTokens = obj.metrics.inputTokens || 0;
      this.metrics.outputTokens = obj.metrics.outputTokens || 0;
      this.metrics.totalTokens = obj.metrics.totalTokens || 0;
      this.metrics.responseTime = obj.metrics.responseTime || 0;
    }

    if (obj.tokens_used !== undefined) {
      this.metrics.tokensUsed = obj.tokens_used;
      this.metrics.inputTokens = obj.tokens_used;
    }
    if (obj.response_start_latency !== undefined) {
      this.metrics.responseStartLatency = obj.response_start_latency;
    }
    if (obj.response_complete_latency !== undefined) {
      this.metrics.responseCompleteLatency = obj.response_complete_latency;
    }
  }
}
